import { CalendarClock, Route, Moon, Trophy } from "lucide-react";
import { resolveUrl } from "@/lib/api";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";

const ABOUT_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/i5hw6p7x_Novemberka%CC%8Asan%202025-17.webp";

const FACTS = [
  { icon: CalendarClock, value: "1915", label: "Första loppet" },
  { icon: Route, value: "~30 mil", label: "Terräng" },
  { icon: Moon, value: "Dag + 2 natt", label: "Etapper" },
  { icon: Trophy, value: "Enduro typ 1", label: "Format" },
];

export const AboutRace = () => {
  return (
    <>
      {/* What is it - for newcomers */}
      <section data-testid="about-race" className="relative py-16 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
            <Reveal>
              <SectionHeader kicker="Vad är Novemberkåsan?" title="Legenden i mörkret" />
              <div className="mt-6 space-y-4 text-base sm:text-lg text-white/70 leading-relaxed">
                <p>
                  Novemberkåsan är en av världens äldsta och tuffaste endurotävlingar. Varje senhöst samlas
                  Sveriges skickligaste terrängförare för att ta sig igenom mil efter mil av lera, myrar,
                  vattendrag och kolsvart skog i novembermörkret.
                </p>
                <p>
                  Tävlingen körs som enduro (typ 1): en krävande dagsetapp följt av två nattetapper där förare och
                  maskin prövas till bristningsgränsen. Det handlar inte bara om fart – det handlar om att
                  överhuvudtaget ta sig fram, och att hålla ut. Att nå målgång räknas som en bragd i sig, och
                  nattetappen med pannlampornas ljus genom dimman avgör ofta det hela.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="relative group overflow-hidden rounded-2xl border border-white/10">
                <img src={resolveUrl(ABOUT_IMG)} alt="Novemberkåsan enduro i lera" loading="lazy" className="aspect-ken aspect-[4/3] w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
            </Reveal>
          </div>

          <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px rounded-2xl overflow-hidden border border-white/10 bg-white/10">
            {FACTS.map((f, i) => (
              <Reveal key={i} className="bg-[#0F1114]">
                <div className="px-5 py-8 text-center">
                  <f.icon className="w-6 h-6 text-amber-500 mx-auto" />
                  <div className="mt-3 font-display text-3xl sm:text-4xl font-black text-white">{f.value}</div>
                  <div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-white/50">{f.label}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* History narrative */}
      <section className="relative py-16 sm:py-24 bg-[#0A0B0D]">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <SectionHeader kicker="Historien" title="Mer än ett sekel av kamp" center />
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-4 text-base sm:text-lg text-white/70 leading-relaxed">
              <p>
                Novemberkåsan arrangeras av Svenska Motorklubben (SMK) och kördes första gången 1915 i Stockholm,
                där Gunnar Enderlein tog segern på en Royal Enfield. Sedan dess har tävlingen körts nästan varje år.
              </p>
              <p>
                Undantagen är få och historiska: slutet av första världskriget (1917–1918), andra världskrigets
                beredskapsår (1939–1945), högertrafikomläggningen 1967 och coronapandemin 2020. Förr kunde loppet
                sträcka sig 60–70 mil på byvägar – idag är det ren, obarmhärtig enduroterräng.
              </p>
              <p>
                2015 firades 100-årsjubileum i Uddevalla. Traditionen med en vandringskåsa lever kvar: den förare som
                erövrar tre inteckningar på samma kåsa får behålla den – ett av svensk motorsports mest åtråvärda troféer.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};
